/* eslint-disable eslint-comments/disable-enable-pair -- needed */
import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { IconSearch } from '@americanexpress/dls-icons';
import { Button, Heading } from '@americanexpress/dls-react';
import { determineColStyle } from '../utils';
import styles from '../styles/viewall.css';
import CardBenefitsTileSansCatalog from './card-benefits-tile/CardBenefitsTileSansCatalog';
import AnalyticsClick from '../../shared/components/analyticsClick';

export default function GridSansCatalog(props) {
  const benefitNames = props?.benefitNames;
  const benefits = props?.benefits;
  const cardname = props?.cardname;
  const login = props?.login;
  const columns = props?.columns;
  const mobileView = props?.mobileView;
  const isListView = props?.isListView;
  const analyticsTag = props?.analyticsTag;
  const productSelected = props?.productSelected;
  const searchValue = props?.searchFilter;
  const localeDetails = props?.localeDetails;

  const generatedMessage = () => {
    return (
      <div
        className={`pad-responsive stack flex flex-column flex-justify-center margin-0-lr margin-1-b text-align-center ${`${styles.generatedMsg}`} `}
      >
        <IconSearch
          data-testid="iconSearch"
          color="subtle"
          size={window.screen.availWidth > 768 ? 'lg' : 'md'}
        />
        <Heading level={2} varient="sans-medium-regular">
          <FormattedMessage
            id="view-all.search.no-data-heading"
            defaultMessage="We couldn't find search results for "
          />
          {`"${searchValue}."`}
        </Heading>
        <p>
          <FormattedMessage
            id="view-all.search.no-data"
            defaultMessage="Please check your spelling or try a different search term. "
          />
        </p>
        <AnalyticsClick
          element={`${props.cardname}>>search>>new-search`}
          onClick={props.newSearch}
        >
          <Button
            type="submit"
            className="margin-auto-lr"
            variant="primary"
          >
            <FormattedMessage
              id="view-all.search.new-search"
              defaultMessage="New Search"
            />
          </Button>
        </AnalyticsClick>
      </div>
    );
  };

  if (benefitNames && benefits) {
    const generateRows = () => {
      const items = [];
      const benefitOrderList = [];
      benefitNames.forEach((id) => {
        if (id in benefits) {
          benefitOrderList.push(id);
        }
      });
      benefitOrderList.forEach((id, idx) => {
        const colWidths = isListView
          ? 'col-xs-12 col-sm-12 col-md-12 col-lg-12 pad-0'
          : `col-md-6 col-lg-4 pad-0-l ${determineColStyle(columns, idx)}`;
        items.push(
          <div
            className={
              mobileView
                ? null
                : `${colWidths} ${determineColStyle(columns, idx)}`
            }
            key={`tile-${benefits[id].benefitName}`}
          >
            <CardBenefitsTileSansCatalog
              benefitName={benefits[id].benefitName}
              view="view-all"
              benefitId={id}
              benefit={benefits[id]}
              cardname={cardname}
              login={login}
              showMobileTileView={mobileView}
              isListView={isListView}
              analyticsTag={analyticsTag}
              productSelected={productSelected}
              showTerms={false}
              benefitNamesList={benefitOrderList}
              benefitsData={benefits}
              localeDetails={localeDetails}
            />
          </div>
        );
      });
      return items;
    };
    return (
      <div
        className={
          mobileView
            ? null
            : `flex flex-wrap flex-align-content-start ${`${styles.gridWidth} margin-center`} `
        }
      >
        {benefitNames.length === 0 ? generatedMessage() : generateRows()}
      </div>
    );
  }
  return null;
}

GridSansCatalog.propTypes = {
  benefitNames: PropTypes.arrayOf(PropTypes.string),
  login: PropTypes.bool,
  columns: PropTypes.number.isRequired,
  mobileView: PropTypes.bool,
  benefits: PropTypes.shape({}).isRequired,
  isListView: PropTypes.bool,
  analyticsTag: PropTypes.string,
  productSelected: PropTypes.string,
  searchFilter: PropTypes.string,
  newSearch: PropTypes.func,
};

GridSansCatalog.defaultProps = {
  benefitNames: null,
  login: false,
  mobileView: false,
  isListView: false,
  analyticsTag: 'null',
  productSelected: 'null',
};
